import Logger from '../../../utils/logger';

export default class BaseTracker {
  _player = null;
  _ad = null;
  _event = null;

  constructor(player, ad, event) {
    this._player = player;
    this._ad = ad;
    this._event = event;
  }

  start() {
  }

  stop() {
  }

  track() {
    for (const beaconUrl of this._event.beaconUrls) {
      // we intentionally call all beacons in parallel
      fetch(beaconUrl, {
        mode: 'no-cors',
      }).then(
        () => {
          Logger.debug(`daitracker: tracked ${this._event.eventType}`);
        },
        (e) => {
          Logger.warn(`daitracker: Failed to track ${this._event.eventType}`, e);
        },
      );
    }
  }

  _toAbsoluteTime(timestamp) {
    return this._player._shakaPlayer.playerTimeToAbsoluteTime(timestamp);
  }
}
